import { convertDateTime } from "../Utils/utils"

export const mutations = {
  increaseCurrentCount: (state) => {
    state.onDirect = false;
    state.currentCount++;
    startTimer(state);
  },

  increaseScore: (state, stakeValue) => {
    const cp = state.passingSequence[state.currentCount];
    state.scoreTable.scores = state.scoreTable.scores.map((x, i) => i === cp ? x + stakeValue : x)
  },

  increaseOwns: (state, payload) => {
    const cp = state.passingSequence[state.currentCount];
    state.scoreTable.owns = state.scoreTable.owns.map((x, i) => i === cp ? [x[0] + payload[0], x[1] + payload[1]] : x)
    if (payload[0] > 0) {
      state.scoreTable.roundSummary = state.scoreTable.roundSummary.map((x, i) => {
        if (i === cp) {
          return [x[0], x[1] + 1, x[2]]
        } else {
          return x;
        }
      })
    }
  },

  increaseCorrect: (state) => {
    const cp = state.passingSequence[state.currentCount];
    state.scoreTable.totalCorrect = state.scoreTable.totalCorrect.map((x, i) => i === cp ? x + 1 : x)
    state.scoreTable.roundSummary = state.scoreTable.roundSummary.map((x, i) => {
      if (i === cp) {
        return [x[0] + 1, x[1], x[2]]
      } else {
        return x;
      }
    })
  },

  increaseStakesCorrect: (state, stakeValue) => {
    const sv = `stake${stakeValue}`;
    const cp = state.passingSequence[state.currentCount];
    state.scoreTable[sv] = state.scoreTable[sv].map((x, i) => i === cp ? [x[0] + 1, x[1] + 1] : x)
  },

  increaseStakesWrong: (state, stakeValue) => {
    const sv = `stake${stakeValue}`;
    const cp = state.passingSequence[state.currentCount];
    state.scoreTable[sv] = state.scoreTable[sv].map((x, i) => i === cp ? [x[0], x[1] + 1] : x)
  },

  increaseBonusAttempts: (state) => {
    const cp = state.passingSequence[state.currentCount];
    state.scoreTable.bonusAttempts = state.scoreTable.bonusAttempts.map((x, i) => i === cp ? x + 1 : x)
  },

  increaseBonusPoints: (state) => {
    const cp = state.passingSequence[state.currentCount];
    state.scoreTable.bonusPoints = state.scoreTable.bonusPoints.map((x, i) => i === cp ? x + 1 : x)
  },

  increaseNotAnswered: (state) => {
    const cp = state.passingSequence[0];
    state.scoreTable.notAnswered = state.scoreTable.notAnswered.map((x, i) => i === cp ? x + 1 : x)
    state.scoreTable.roundSummary = state.scoreTable.roundSummary.map((x, i) => {
      if (i === cp) {
        return [x[0], x[1], x[2] + 1]
      } else {
        return x;
      }
    })
  },
  decreaseScore: (state, stakeValue) => {
    const cp = state.passingSequence[state.currentCount];
    state.scoreTable.scores = state.scoreTable.scores.map((x, i) => i === cp ? x - stakeValue : x)
  },

  appendGameString: (state, action) => {
    state.gamePlayString = state.gamePlayString + action;
    state.gamePlayPointer = state.gamePlayString.length;
  },

  appendCurrentActionSequence: (state, action) => {
    state.currentActionSequence = state.currentActionSequence + action;
  },


  closeQuestion: (state) => {
    resetTimer(state);
    state.questionDisplayMode = "ShowAnswer"
  },

  resetTimer: (state) => {
    resetTimer(state);
  },

  setOnDirect: (state, value) => {
    state.onDirect = value
  },

  incrementQuestion: (state) => {
    state.onDirect = true;
    state.current.question++;
    state.currentCount = 0;
    if (state.current.question > state.numDirects) {
      state.current.player++;
      state.current.question = 1;
      if (state.current.player >= state.numPlayers) {
        state.current.round++;
        state.current.player = 0;
        state.scoreTable.previousSummary = state.scoreTable.roundSummary;
        state.scoreTable.roundSummary = [...Array(state.numPlayers).keys()].map(_x => [0, 0, 0]);
      }
    }

    state.passingSequence = get_sequence(state.scoreTable.bonusAttempts.slice(0, state.numPlayers), state.current.player)

    state.currentQuestionNo++;
  },

  setPassingSequence(state) {
    state.passingSequence = get_sequence(state.scoreTable.bonusAttempts.slice(0, state.numPlayers), state.current.player)
  },

  updateScoreTable: (state, { value, pId, property }) => {
    state.scoreTable[property][pId] = value
  },

  startTimer: (state) => {
    startTimer(state)
  },

  setAutoPass: (state, t) => {
    state.timer.autoPass = t;
  },

  toggleEmpty: (state, playerId) => {
    state.players = state.players.map(x => x.id !== playerId ? x : { ...x, emptySeat: !x.emptySeat })
  },

  toggleSelfReadValue: (state) => {
    state.selfReadSwitch = !state.selfReadSwitch;
  },

  toggleFreeDirect: (state) => {
    state.freeDirect = !state.freeDirect;
  },

  togglePeekAnswer: (state) => {
    state.peekAnswer = !state.peekAnswer;
  },

  toggleResumeGame: (state) => {
    state.resumeGame = !state.resumeGame;
  },

  setInstructions: (state, instructions) => {
    state.instructions = instructions
  },

  setGameNotes: (state, gameNotes) => {
    state.gameNotes = gameNotes
  },

  incrementTime: (state) => {
    if (state.timer.timer) {
      state.timer.displayTime = state.timer.displayTime + state.timer.adjustTime;
    } else {
      state.timer.timer = setInterval(() => {
        if (state.timer.displayTime <= 0) {
          clearInterval(state.timer.timer)
          state.timer.timer = null;
        } else {
          state.timer.displayTime = parseInt(state.timer.displayTime) - 1
        }
      }, state.timer.INTERVAL)
    }
  },

  decrementTime: (state) => {
    if (state.timer.displayTime >= state.timer.adjustTime) {
      state.timer.displayTime = state.timer.displayTime - state.timer.adjustTime
    }
    else {
      clearInterval(state.timer.timer)
      state.timer.timer = null
      state.timer.displayTime = 0
    }
  },

  setPlayerNames(state, listOfPlayers) {
    state.players.filter(p => !p.emptySeat).forEach((x, index) => {
      x.name = listOfPlayers[index]
    })
  },

  setLog(state, logText) {
    state.log = logText
  },

  changePlayers(state, p) {
    if (p > state.players.length) {
      for (var i = state.numPlayers; i < p; i++) {
        state.players.push(
          {
            name: ``,
            id: i,
            placeholder: `Player ${i + 1}`,
            emptySeat: false,
          }
        )
      }
    }
    state.numPlayers = p
    state.passingSequence = [...Array(p).keys()]

    state.scoreTable = {
      scores: [...Array(p).keys()].map(_x => 100),
      owns: [...Array(p).keys()].map(_x => [0, 0]),
      bonusAttempts: [...Array(p).keys()].map(_x => 0),
      notAnswered: [...Array(p).keys()].map(_x => 0),
      totalCorrect: [...Array(p).keys()].map(_x => 0),
      stake5: [...Array(p).keys()].map(_x => [0, 0]),
      stake10: [...Array(p).keys()].map(_x => [0, 0]),
      stake20: [...Array(p).keys()].map(_x => [0, 0]),
      bonusPoints: [...Array(p).keys()].map(_x => 0),
      roundSummary: [...Array(p).keys()].map(_x => [0, 0, 0]),
      previousSummary: [...Array(p).keys()].map(_x => [0, 0, 0]),
    }
  },
  changeDirects(state, d) {
    state.numDirects = d
  },
  changeRounds(state, r) {
    state.numRounds = r;
  },
  changeCurrentPosition(state, r) {
    state.numRounds = r
  },

  calcTotalQuestions(state) {
    state.totalQuestions = state.numRounds * state.numPlayers * state.numDirects;
  },

  calcCurrent(state) {
    state.current = {
      round: 1,
      player: 0,
      question: 1
    }

    for (let i = 0; i < state.currentQuestionNo; i++) {
      state.current.question++
      if (state.current.question > state.numDirects) {
        state.current.question = 1
        state.current.player++
        if (state.current.player == state.numPlayers) {
          state.current.player = 0
          state.current.round++
        }
      }
    }
  },

  restartGame: (state, replay = false) => {
    state.currentQuestionNo = 0;
    state.currentCount = 0;
    state.current = {
      round: 1,
      player: 0,
      question: 1,
    };
    const p = state.numPlayers
    state.passingSequence = [...Array(p).keys()]
    state.scoreTable = {
      scores: [...Array(p).keys()].map(_x => 100),
      owns: [...Array(p).keys()].map(_x => [0, 0]),
      bonusAttempts: [...Array(p).keys()].map(_x => 0),
      notAnswered: [...Array(p).keys()].map(_x => 0),
      totalCorrect: [...Array(p).keys()].map(_x => 0),
      stake5: [...Array(p).keys()].map(_x => [0, 0]),
      stake10: [...Array(p).keys()].map(_x => [0, 0]),
      stake20: [...Array(p).keys()].map(_x => [0, 0]),
      bonusPoints: [...Array(p).keys()].map(_x => 0),
      roundSummary: [...Array(p).keys()].map(_x => [0, 0, 0]),
      previousSummary: [...Array(p).keys()].map(_x => [0, 0, 0]),
    }
    state.gamePlayHistory = []
    state.questionDisplayMode = "Start"
    state.finishGame = false;
    if (!replay) {
      state.gameStartTime = convertDateTime(new Date())
      state.game = ""
    }
    state.currentActionSequence = ""
    state.gamePlayString = ""
    state.gamePlayPointer = 0
  },

  setGameId: (state, gameId) => {
    state.gameId = gameId
  },

  setObjectId: (state, objectId) => {
    state.objectId = objectId
  },

  setListOfPlayers: (state, listOfPlayers) => {
    state.listOfPlayerNames = listOfPlayers.map(x => ({ ...x, fullName: `${x.displayName} (${x.playerName})` }))
  },

  setGameType: (state, gameType) => {
    state.gameType = gameType
  },

  setReaderName: (state, name) => {
    state.readerName = name
  },

  finishGame: (state) => {
    state.finishGame = true
  },

  toggleRandomiserMode: (state) => {
    state.b612Friendly = !state.b612Friendly
  },

  setLeagueParams: (state, payload) => {
    state.leagueName = payload.l;
    state.leagueSeason = payload.s;
    state.gameWeek = payload.w;
    state.matchNumber = payload.m;
    state.leagueMatch = true;
    state.readerName = payload.r;
  },

  loadGameData: (state, data) => {
    state.fileName = data.fileName;
    state.finishGame = data.finishGame
    state.gameId = data.gameId
    state.gameType = data.gameType
    state.numDirects = data.numDirects
    state.numPlayers = data.numPlayers
    state.numRounds = data.numRounds
    state.players = data.players
    state.scoreTable = data.scoreTable
    state.readerName = data.readerName
    state.gamePlayString = data.gamePlayString
    state.currentActionSequence = data.currentActionSequence
    state.gamePlayPointer = data.gamePlayPointer
    state.gameStartTime = data.gameStartTime
    state.currentQuestionNo = data.currentQuestionNo
    state.objectId = data._id
    state.gameNotes = data.gameNotes
    state.leagueName = data.leagueName
    state.leagueSeason = data.leagueSeason
    state.gameWeek = data.gameWeek
    state.matchNumber = data.matchNumber
    state.leagueMatch = data.leagueMatch
    state.freeDirect = Object.hasOwn(data, 'freeDirect') ? data.freeDirect : state.freeDirect
  },

  setQuestionData: (state, questions) => {
    state.questionsList = questions;
    state.totalQuestions = questions.length;
  },
  switchQuestionMode: (state, mode) => {
    state.questionDisplayMode = mode
    if (mode === "Question") {
      state.currentActionSequence = ""
    }
  },
  setFileName: (state, fileName) => {
    state.fileName = fileName
    if (fileName.startsWith("B612_Friendleague")) {
      state.freeDirect = false;
    }
  },
  storeSnapshot: (state) => {
    state.gamePlayHistory.push({
      currentQuestionNo: state.currentQuestionNo,
      currentCount: state.currentCount,
      current: { ...state.current },
      scoreTable: {
        scores: [...state.scoreTable.scores],
        owns: [...state.scoreTable.owns],
        bonusAttempts: [...state.scoreTable.bonusAttempts],
        notAnswered: [...state.scoreTable.notAnswered],
        totalCorrect: [...state.scoreTable.totalCorrect],
        stake5: [...state.scoreTable.stake5],
        stake10: [...state.scoreTable.stake10],
        stake20: [...state.scoreTable.stake20],
        bonusPoints: [...state.scoreTable.bonusPoints],
        roundSummary: [...state.scoreTable.roundSummary],
        previousSummary: [...state.scoreTable.previousSummary],
      },
      onDirect: state.onDirect,
      passingSequence: [...state.passingSequence],
      questionDisplayMode: state.questionDisplayMode,
      finishGame: state.finishGame,
      gamePlayString: state.gamePlayString,
      currentActionSequence: state.currentActionSequence,
      gamePlayPointer: state.gamePlayPointer,
    })
  },
  restoreSnapshot: (state) => {
    const savedState = state.gamePlayHistory.pop();
    state.currentQuestionNo = savedState.currentQuestionNo
    state.currentCount = savedState.currentCount
    state.current = {
      ...savedState.current
    }
    state.scoreTable = {
      scores: [...savedState.scoreTable.scores],
      owns: [...savedState.scoreTable.owns],
      bonusAttempts: [...savedState.scoreTable.bonusAttempts],
      notAnswered: [...savedState.scoreTable.notAnswered],
      totalCorrect: [...savedState.scoreTable.totalCorrect],
      stake5: [...savedState.scoreTable.stake5],
      stake10: [...savedState.scoreTable.stake10],
      stake20: [...savedState.scoreTable.stake20],
      bonusPoints: [...savedState.scoreTable.bonusPoints],
      roundSummary: [...savedState.scoreTable.roundSummary],
      previousSummary: [...savedState.scoreTable.previousSummary],
    }
    state.onDirect = savedState.onDirect
    state.passingSequence = [...savedState.passingSequence]
    state.questionDisplayMode = savedState.questionDisplayMode
    state.finishGame = savedState.finishGame
    state.gamePlayString = savedState.gamePlayString
    state.currentActionSequence = savedState.currentActionSequence
    state.gamePlayPointer = savedState.gamePlayPointer
  },
  setKeyMap: (state, keyMap) => {
    state.keyMap = keyMap
  },

  moveGamePlayPointer: (state, value) => {
    state.gamePlayPointer += value;
  },

  setButtonContainerCompactFlag: (state, flag) => {
    state.buttonContainerCompactFlag = flag
  }
}

function startTimer(state) {
  clearInterval(state.timer.timer);
  state.timer.timer = null;
  state.timer.displayTime = state.onDirect ? state.timer.directTime : state.timer.passTime
  state.timer.timer = setInterval(() => {
    if (state.timer.displayTime <= 0) {
      clearInterval(state.timer.timer)
      state.timer.timer = null
    } else {
      state.timer.displayTime = state.timer.displayTime - 1
    }
  }, state.timer.INTERVAL);
}

function resetTimer(state) {
  clearInterval(state.timer.timer);
  state.timer.timer = null;
  state.timer.displayTime = state.timer.directTime;
}

const get_sequence = (arr, pos) => {
  const result = arr.map((x, i) => [i, x]).sort((e1, e2) => {
    if (e1[1] != e2[1]) {
      return e1[1] - e2[1]
    } else {
      if ((pos < e1[0] && pos < e2[0]) || (pos > e1[0] && pos > e2[0])) {
        return e1[0] - e2[0]
      } else {
        return e2[0] - e1[0]
      }
    }
  }).filter(k => k[0] != pos).map(l => l[0])
  result.unshift(pos);
  return result;
}